import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconOnlineFormProps } from './IconOnlineForm.types'
import * as Styled from './styles/IconOnlineForm.style'

import { nonThemeableRules } from '../../ruleSet'

const IconOnlineForm: FC<IconOnlineFormProps> = ({
  size = nonThemeableRules.defaultSize as number as IconOnlineFormProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconOnlineFormProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M5.973 4.227h14.054v8.41c0 1.101-.898 2-2 2H5.973c-1.102 0-2-.899-2-2v-6.41a2 2 0 0 1 2-2Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M18.45 14.633c.667 0 1.69.183 2.093 1.27.398 1.09.71 1.89.887 2.558.18.668-.086 1.312-1.867 1.312H4.438c-1.782 0-2.047-.644-1.868-1.312.176-.668.489-1.469.887-2.559.402-1.09 1.426-1.27 2.094-1.27ZM6.523 17.238h10.954m.082-9.453-3.543 3.543-1.575-1.574M6 7.43h4m-4 2h4m-4 2h4'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconOnlineForm
